var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 col-lg-4 col-xl-3 order-lg-2" },
      [
        _c("filter-shops", {
          attrs: {
            categories: _vm.marketCategories,
            countries: _vm.marketCountries,
            mainlng: _vm.mainlng,
            lng: _vm.lng,
            translations: _vm.translations,
          },
          on: {
            childToParent: function ($event) {
              return _vm.handleFilter($event)
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-lg-8 col-xl-9 order-lg-1" },
      [
        _c("shop-list", {
          attrs: {
            markets: _vm.marketList,
            mainlng: _vm.mainlng,
            lng: _vm.lng,
          },
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.marketList.length < 1,
                expression: "marketList.length < 1",
              },
            ],
          },
          [_vm._v(_vm._s(_vm.get_translation_constant("text_no_results")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination__block" },
          [
            _c("vue-pagination", {
              attrs: {
                data: _vm.marketListPagination,
                limit: 2,
                size: "small",
                "show-disabled": false,
              },
              on: { "pagination-change-page": _vm.getResults },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }